import config from "../config";
import { requests } from ".";

export const MoveNumbersService = {
  getInboundNumbers: async (payload) => {
    const { locationId = "", showOnlyUSCA = "" } = { ...payload };
    const { data } = await requests(config.REVEX_BACKEND_LC_PHONE_URL).get(
      `numbers/inbound?locationId=${locationId}&showOnlyUSCA=${showOnlyUSCA}&skipNumberPool=true`
    );
    return data;
  },
  moveNumbers: async (payload) => {
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).post(`/phone-system/numbers/move`, payload);
    return data;
  },
};
